import { render, staticRenderFns } from "./General.vue?vue&type=template&id=2aa4bdd8&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa4bdd8')) {
      api.createRecord('2aa4bdd8', component.options)
    } else {
      api.reload('2aa4bdd8', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=2aa4bdd8&", function () {
      api.rerender('2aa4bdd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/General.vue"
export default component.exports